// 注册自定义组件渲染器
import { registerRendererByType } from '@/utils/amis-widget/index.esm.js'
import InfoGrid from './info-grid'

registerRendererByType(InfoGrid, {
  type: 'info-grid',
  usage: 'renderer',
  weight: 99,
  framework: 'vue'
})
